import { IFirstContainer, IFirstWrapper, IGeneralWrapper } from "../../types";

import styled from "styled-components";

const GeneralWrapper = styled.div<IGeneralWrapper>`
  width: 100%;
  height: 100%;
`;

/* ---------------------------------------------------------------------------- */

export const FirstWrapper = styled.div<IFirstWrapper>`
  flex-direction: row;
`;
export const FirstContainer = styled.div<IFirstContainer>`
  background-color: #ffcb0f;
  z-index: 20;

  height: 100%;
`;

export default GeneralWrapper;
